"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const { default: AkDropdownMenu, DropdownItemGroup: AkDropdownItemGroup, DropdownItem: AkDropdownItem } = require("@atlaskit/dropdown-menu");
exports.Dropdown = ({ children, values, onSelect, shouldFlip, position, triggerButtonProps, trigger }) => {
    const onOpenChange = (item) => {
        if (onSelect) {
            onSelect(item);
        }
    };
    return (React.createElement(AkDropdownMenu, { onOpenChange: onOpenChange, triggerType: "button", shouldFlip: shouldFlip, position: position, triggerButtonProps: triggerButtonProps, trigger: trigger }, children || (React.createElement(exports.DropdownItemGroup, null, values.map(v => (React.createElement(exports.DropdownItem, null, v))))) ||
        ""));
};
exports.DropdownItemGroup = AkDropdownItemGroup;
exports.DropdownItem = ({ children, onClick }) => React.createElement(AkDropdownItem, { onClick: onClick }, children);
